import { Component, OnInit } from '@angular/core';
import { faBetamax } from '@fortawesome/pro-duotone-svg-icons';
import { Store } from '@ngxs/store';
import { BrickCategory } from 'src/app/samwebDescription/samweb/brickCategoryType';
import { ToolbarBrickSettingsState } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-brick-settings/toolbar-brick-settings.state';
import { SamwebBrick } from '../../samweb-brick.decorator';
import { ToolbarBrickSettingsComponent } from './toolbar-brick-settings/toolbar-brick-settings.component';
import { ToolbarBrickBaseComponent } from './toolbar-brick.base.component';
import { ToolbarBrickSmallComponent } from './toolbar-brick.small.component';

@Component({
   selector: 'samweb-toolbar-brick',
   templateUrl: './toolbar-brick.default.component.html',
   styleUrls: ['./toolbar-brick.default.component.scss'],
})
@SamwebBrick({
   brickDefinitionId: 'toolbarBrick',
   brickTitleTranslationKey: 'brick.brick_definitions.toolbar_brick.title',
   brickDescriptionTranslationKey: 'brick.brick_definitions.toolbar_brick.description',
   brickIcon: faBetamax,
   minColWidth: 5,
   minRowHeight: 3,
   brickCategory: BrickCategory.LAYOUT,
   settingsComponent: ToolbarBrickSettingsComponent,
   settingStateHandler: ToolbarBrickSettingsState,
   smallBrickComponentAlternative: ToolbarBrickSmallComponent,
})
export class ToolbarBrickDefaultComponent extends ToolbarBrickBaseComponent implements OnInit {
   constructor(store: Store) {
      super(store);
   }
}
